import { Typography } from "@mui/material";

export interface IEmailModalDescriptionWarningProps {
  candidatesCount: number;
  eligibleCandidatesCount: number;
}

export const EmailModalDescriptionWarning = ({
  candidatesCount,
  eligibleCandidatesCount,
}: IEmailModalDescriptionWarningProps) => {
  if (candidatesCount > 1) {
    const deltaCount = candidatesCount - eligibleCandidatesCount;
    if (deltaCount > 1) {
      return (
        <Typography variant="body1" color="secondary">
          Vous avez sélectionné {candidatesCount} candidats afin de leur envoyer un email. Cependant {deltaCount}{" "}
          d’entre eux n’ont pas d’email ou n’ont pas accepté ce mode de contact. Seuls les candidats remplissant les
          conditions d’envoi recevront l’email.
        </Typography>
      );
    }
    return (
      <Typography variant="body1" color="secondary">
        Vous avez sélectionné {candidatesCount} candidats afin de leur envoyer un email. Cependant un d’entre eux n’a
        pas d’email ou n’a pas accepté ce mode de contact. Seuls les candidats remplissant les conditions d’envoi
        recevront l’email.
      </Typography>
    );
  }
  return (
    <Typography variant="body1" color="secondary">
      Vous avez sélectionné un candidat afin de lui envoyer un email. Cependant celui-ci n'a pas d'email ou n'a pas
      accepté ce mode de contact. Seul un candidat remplissant les conditions d’envoi peut recevoir un email.
    </Typography>
  );
};
